import { render, staticRenderFns } from "./DadosGerais.vue?vue&type=template&id=0083deaf&scoped=true&"
import script from "./DadosGerais.vue?vue&type=script&lang=js&"
export * from "./DadosGerais.vue?vue&type=script&lang=js&"
import style0 from "./DadosGerais.vue?vue&type=style&index=0&id=0083deaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0083deaf",
  null
  
)

export default component.exports